import type { HandlerType, StatusType } from '@datadog/browser-logs';
import { datadogLogs } from '@datadog/browser-logs';

import type { DataDogConfig, LogContext } from '../types';

export const isDataDogInitialized = () =>
  Boolean(datadogLogs.getInternalContext());

export const initDataDog = (
  {
    clientToken,
    forwardErrorsToLogs,
    service,
    sessionSampleRate,
    site,
  }: DataDogConfig,
  context: LogContext,
) => {
  datadogLogs.init({
    clientToken,
    forwardErrorsToLogs: forwardErrorsToLogs || false,
    service,
    sessionSampleRate: sessionSampleRate || 100,
    site,
  });

  datadogLogs.setGlobalContext(context);
};

export const refreshContext = (context: LogContext) => {
  datadogLogs.setGlobalContext(context);
};

export const createLogger = (name: string, type = 'console', level = 'info') =>
  datadogLogs.createLogger(name, {
    handler: type as HandlerType,
    level: level as StatusType,
  });
